import React from 'react'
import {ContentHotel} from '@findhotel/sapi'
import {CompactOfferList} from 'components/OfferList/CompactOfferList/CompactOfferList'
import {HotelOfferEntity} from 'modules/sapiSearch/slice'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {PopUp} from '@vio/atlas/PopUp'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {BOFH_PROXY_PROVIDER_CODE} from '@vio/core/src/offer/business/isBofhOffer'

import {ExitPopupContent} from './ExitPopupContent'
import {ExitPopupHeader} from './ExitPopupHeader'
import {ExitPopupSkeleton} from './ExitPopupSkeleton'
import {MODAL_WIDTH, PopupOffersContainer} from './styles'
import {useExitPopup} from './useExitPopup'

interface Props {
  hotel: ContentHotel | undefined
  offerEntity?: HotelOfferEntity
  isLoading: boolean
}

export const ExitPopupAccommodationPage = ({
  hotel,
  offerEntity,
  isLoading
}: Props) => {
  const {isMobile} = useDeviceLayout()
  const {
    monetisation: {cashback}
  } = useBrandCapabilities()
  const offersToShow = offerEntity?.offers
    ?.filter(offer => offer.intermediaryProvider !== BOFH_PROXY_PROVIDER_CODE)
    ?.slice(0, 3)

  const {dismissPopup, isOpen} = useExitPopup({
    page: 'Accommodation',
    isEnabled: Boolean(offersToShow?.length)
  })

  if (!isOpen) return null

  if (isLoading) {
    return (
      <PopUp
        width={MODAL_WIDTH}
        isOpen={isOpen}
        closeAction={dismissPopup}
        navBarProps={{
          centerContent: (
            <ExitPopupHeader variant="loading" isMobile={isMobile} />
          ),
          centerAligned: true,
          variant: 'inverse'
        }}
      >
        <ExitPopupSkeleton />
      </PopUp>
    )
  }

  const {anchorPriceNightly, anchorPrice} = offerEntity?.topOfferData || {}

  return (
    <PopUp
      width={MODAL_WIDTH}
      isOpen={isOpen}
      noPaddings
      navBarProps={{
        centerContent: <ExitPopupHeader variant="accommodationPage" />,
        centerAligned: true,
        variant: 'inverse'
      }}
      closeAction={dismissPopup}
    >
      <>
        <ExitPopupContent hotel={hotel} />
        <Box paddingLeft="s600" paddingRight="s600">
          <Divider />
        </Box>
        <PopupOffersContainer>
          <CompactOfferList
            offers={offersToShow}
            isLoading={false}
            hotelId={hotel.objectID}
            anchorPrice={anchorPriceNightly}
            anchorPriceTotal={anchorPrice}
            sourceComponent="ExitPopupAccommodationPage"
            showFooter={false}
            showArrowCta={false}
            showCashback={cashback.enabled}
            showCashbackLineBreak
          />
        </PopupOffersContainer>
      </>
    </PopUp>
  )
}
